// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___G3Tt","container":"styles_container__t_Nmw","slide":"styles_slide__ZeA1u"};